<!-- Evaluation REFERRAL component -->
<template>
  <div>
    <md-card id="referral">
      <!-- align="Left" -->
      <md-card-header class="md-card-header-icon md-card-header-green">
        <div class="card-icon"><i class="fas fa-2x fa-user-md"></i></div>
        <h4 class="title">Referral Doctors</h4>

        <div class="md-layout md-gutter md-layout-item md-size-100 md-alignment-center-right">
          <div class="md-layout md-gutter md-layout-item md-size-20">
            <md-field class="md-sm"> <label>search</label><md-input v-model="searchTxt" /> </md-field>
          </div>

          <!--FILTER-DropDown-->
          <!-- <div v-if="false" class="md-layout md-gutter md-layout-item md-align-right">
            <drop-down direction="down">
              <md-button slot="title" class="md-button md-primary md-sm md-block dropdown-toggle"
                data-toggle="dropdown">
                Filter
              </md-button>

              <ul class="dropdown-menu ">
                <li style="padding-left: 7px;" @click="getList('NAME')">
                  Filter by Name
                </li>
                <li style="padding-left: 7px;" @click="getList('ZIPCODE')">
                  Filter by Zip Code
                </li>
                <li style="padding-left: 7px;" @click="getList('STATE')">
                  Filter by State
                </li>
                <li style="padding-left: 7px;" @click="getList('COUNTRY')">
                  Filter by Country
                </li>
                <li style="padding-left: 7px;" @click="getList('QUALS')">
                  Filter by Qualifications
                </li>
                <li style="padding-left: 7px;" @click="getList('BIZ')">
                  Filter by Business/Web
                </li>
              </ul>
            </drop-down>
          </div> -->

          <!--FILTER-Input-->
          <!-- <div v-if="false" class="md-layout-item  md-align-right">
            <md-field class="md-sm">
              <label>{{ queryLabel }}</label><md-input v-model="queryTxt" />
            </md-field>
          </div> -->

          <!--REFRESH-->
          <!-- <div v-if="false" class="md-layout-item md-size-10">
            <md-button class="md-sm md-success" @click="refresh">refresh
              <md-tooltip md-direction="bottom">Refresh Doctors List</md-tooltip>
            </md-button>
          </div> -->
        </div>

        <!--HEADINGS-->
        <!-- <div class="md-layout md-gutter" style="margin-top: 20px; font-size: .85em; font-weight: 500;">
          <div class="md-layout-item md-size-5"/>
          <div class="md-layout-item md-size-20" style="margin-left:15px;" md-button @click="sortBy('Doctor')"><u>Doctor/Practice</u>
            <md-tooltip md-direction="bottom">SORT MD's by Name</md-tooltip>
          </div>
          <div class="md-layout-item md-size-10" style="margin-left:15px;">Phone</div>
          <div class="md-layout-item md-size-10" md-button @click="sortBy('City')"><u>City</u>
            <md-tooltip md-direction="bottom">SORT MD's by City</md-tooltip>
          </div>
          <div class="md-layout-item md-size-5" md-button @click="sortBy('State')"><u>State</u>
            <md-tooltip md-direction="bottom">SORT MD's by State</md-tooltip>
          </div>
          <div class="md-layout-item md-size-5" md-button @click="sortBy('Zip')"><u>ZIP</u>
            <md-tooltip md-direction="bottom">SORT MD's by Zip</md-tooltip>
          </div>
          <div class="md-layout-item md-size-15" md-button @click="sortBy('Country')"><u>Country</u>
            <md-tooltip md-direction="bottom">SORT by Country</md-tooltip>
          </div>
          <div class="md-layout-item md-size-15">Address</div>
          <div class="md-layout-item " md-button @click="sortBy('Specialization')"><u>Specialization</u>
            <md-tooltip md-direction="bottom">SORT MD's by Specialization</md-tooltip>
          </div>
                      </div> -->

        <hr />
      </md-card-header>

      <md-card-content>
        <md-table
          v-model="filteredDoctorsList"
          class="table-shopping table-striped table-hover"
          @click.native="labelSort($event)"
        >
          <md-table-row slot="md-table-row" slot-scope="{ item }" :class="getClass(item)" @click="showDocDetail(item)">
            <md-table-cell md-label="">
              <div>
                <md-checkbox v-model="selected" :value="item.id" @change="chkChange(item)" />
              </div>
            </md-table-cell>

            <md-table-cell md-label="name" class="td-name">
              <!--md-label="Doctor" -->
              <a href="#" style="font-size: 0.9rem; font-weight: 400" @click="showDocDetail(item)"
                >{{ item.FullName }}, {{ item.Title }}</a
              >
              <br />
              <small>{{ item.Practice }}</small>
            </md-table-cell>

            <md-table-cell md-label="phone"
              ><small>{{ item.CellNumber }}</small></md-table-cell
            >
            <!--md-label="Phone"-->
            <md-table-cell md-label="city">{{ item.City }}</md-table-cell>
            <!--md-label="City"-->
            <md-table-cell md-label="state">{{ item.State }}</md-table-cell>
            <!--md-label="State"-->
            <md-table-cell md-label="country">{{ item.Country }}</md-table-cell>
            <!--md-label="Country"-->
            <md-table-cell md-label="address">
              <!--md-label="Address/Website"-->
              <small>{{ item.Address }}</small> <br />
              <small
                ><a :href="item.Website">{{ item.Website }}</a></small
              >
            </md-table-cell>

            <md-table-cell md-label="speciality">
              <!--md-label="Speciality"-->
              <!-- <small>{{ item.Specialization }}</small> <br> -->
              <small>{{ item.SubSpecialization }}&nbsp;{{ item.Specialties }}</small>
            </md-table-cell>
            <md-table-cell />
          </md-table-row>
        </md-table>

        <div class="table table-stats" align="left">
          <div class="text-right">
            <hr />
            <div class>
              <p class="card-category" style="margin-top: 10px">
                Showing &nbsp;<b
                  ><u>{{ total }}</u></b
                >&nbsp; {{ Results_Qualifier }}
              </p>
            </div>
          </div>
        </div>
      </md-card-content>
    </md-card>
    <DoctorDetailsModal
      :modelValue="showDocDetails"
      :doctor="selectedDoctor"
      @update:modelValue="showDocDetails = $event"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import DoctorDetailsModal from '@/components/modals/DoctorDetailsModal.vue';
import { Modal } from "@/components"
export default {
  name: "EvalReferral",
  components: {
    Modal,
    DoctorDetailsModal
  },
  props: {
    mZip: {
      type: String,
      required: false,
      default: null
    },
    mCity: {
      type: String,
      required: false,
      default: null
    },
    mState: {
      type: String,
      required: false,
      default: null
    }
  },
  data() {
    return {
      STATUS: null,
      api_Route: "", // '/drqualmd/null/null/null',    // field / value / sort-order (lname, city, state, zip) / asc | desc

      route_lastName: "/dractive/lname/null/asc", // field / value / sort-order (lname, city, state, zip) / asc | desc
      route_lastNameDesc: "/drqualmd/lname/null/desc", // field / value / sort-order (lname, city, state, zip) / asc | desc

      route_city: "/drqualmd/city/null/asc", // field / value / sort-order (lname, city, state, zip) / asc | desc
      route_cityDesc: "/drqualmd/city/null/desc", // field / value / sort-order (lname, city, state, zip) / asc | desc

      route_state: "/drqualmd/state/null/asc", // field / value / sort-order (lname, city, state, zip) / asc | desc
      route_stateDesc: "/drqualmd/state/null/desc", // field / value / sort-order (lname, city, state, zip) / asc | desc

      route_zip: "/drqualmd/zip/null/asc", // field / value / sort-order (lname, city, state, zip) / asc | desc
      route_zipDesc: "/drqualmd/zip/null/desc", // field / value / sort-order (lname, city, state, zip) / asc | desc

      route_specialization: "/drqualmd/specialize/null/asc", // field / value / sort-order (lname, city, state, zip) / asc | desc
      route_specializationDec: "/drqualmd/specialize/null/desc", // field / value / sort-order (lname, city, state, zip) / asc | desc

      doctorsList: [],
      doctorsListCount: 0,
      pageOffset: 0,
      activeURL: "",
      defaultURL: "/dractive/null/null",
      defaultZipcode: "",

      filterState: false,
      showDocDetails: false,
      docDetailName: "",
      selectedDoctor: {},

      arrow: {
        none: "",
        up: "arrow_drop_up",
        down: "arrow_drop_down"
      },
      n_arrow: "",
      c_arrow: "",
      p_arrow: "",
      clearQual: true,
      searchTxt: "",
      queryTxt: "",
      queryLabel: "query",
      search: {
        qualification: "",
        specialization: null,
        doctor: null,
        address: null,
        zip: null,
        city: null,
        other: null
      },
      payload: [],
      doctors: [],
      selected: [],
      doctor: {},
      pageNumber: 0,
      pageSize: 4,
      rstlQual: "",
      activeZip: ""
    }
  },

  computed: {
    ...mapGetters(["patientInfo", "referrals", "getSavedReferrals"]), //"doctorsList",

    readyToProcessReferrals() {
      if (this.getSavedReferrals && this.doctorsList) {
        return {
          referrals: this.getSavedReferrals,
          doctors: this.doctorsList
        }
      }
      return null
    },
    filteredDoctorsList() {
      if (this.searchTxt) {
        var self = this

        // Convert null values to '' so toLowerCase() will work on compare

        var restul_A = this.doctorsList.filter(function (a) {
          a.FullName = a.FullName ? a.FullName : ""
          a.Practice = a.Practice ? a.Practice : ""
          a.Title = a.Title ? a.Title : ""
          a.CellNumber = a.CellNumber ? a.CellNumber : ""
          a.City = a.City ? a.City : ""
          a.State = a.State ? a.State : ""
          a.Zip = a.Zip ? a.Zip : ""
          a.Country = a.Country ? a.Country : ""
          a.Address = a.Address ? a.Address : ""
          a.Website = a.Website ? a.Website : ""
          a.Specialization = a.Specialization ? a.Specialization : ""
          a.SubSpecialization = a.SubSpecialization ? a.SubSpecialization : ""

          return (
            a.FullName.toLowerCase().includes(self.searchTxt.toLowerCase()) ||
            a.Practice.toLowerCase().includes(self.searchTxt.toLowerCase()) ||
            a.Title.toLowerCase().includes(self.searchTxt.toLowerCase()) ||
            a.CellNumber.toLowerCase().includes(self.searchTxt.toLowerCase()) ||
            a.City.toLowerCase().includes(self.searchTxt.toLowerCase()) ||
            a.State.toLowerCase().includes(self.searchTxt.toLowerCase()) ||
            a.Zip.toLowerCase().includes(self.searchTxt.toLowerCase()) ||
            a.Country.toLowerCase().includes(self.searchTxt.toLowerCase()) ||
            a.Address.toLowerCase().includes(self.searchTxt.toLowerCase()) ||
            a.Website.toLowerCase().includes(self.searchTxt.toLowerCase()) ||
            a.Specialization.toLowerCase().includes(self.searchTxt.toLowerCase()) ||
            a.SubSpecialization.toLowerCase().includes(self.searchTxt.toLowerCase())
          )
        })

        return restul_A
      } else {
        return this.doctorsList
      }
    },

    endpoint() {
      return this.activeURL
    },
    page_no() {
      return this.pageOffset
    },
    maxPages() {
      return Math.ceil(this.doctorsListCount / 50)
    },

    total() {
      return this.filteredDoctorsList.length > 0 ? this.filteredDoctorsList.length : this.filteredDoctorsList.length
    },
    Results_Qualifier() {
      if (this.rstlQual) {
        return "by " + this.rstlQual
      } else {
        return "entries"
      }
    }
  },

  created: function () {},
  watch: {
    readyToProcessReferrals(newVal) {
      if (newVal) {

        newVal.referrals.forEach((ref) => {
          const alreadyAdded = this.referrals.find((x) => x.doctorId === ref.doctorID)
          if (!alreadyAdded) {
            const doctor = newVal.doctors.find((x) => x.expr1 === ref.doctorID)
            if (doctor) {
              this.addReferral(doctor)
              this.selected.push(doctor.id)
            }
          }
        })
      }
    }
  },
  mounted: function () {
    this.activeURL = this.defaultURL
    //    if (this.mZip != null || this.mZip != "") {
    //      this.queryTxt = this.mZip
    //      // console.log("by zip: " + this.queryTxt)
    //      this.getList("ZIPCODE")
    //    } else if (this.mState != null || this.mState != "") {
    //      this.queryTxt = this.mState
    // console.log("by state: " + this.queryTxt)
    //      this.getList("STATE")
    //    } else {
    // console.log("by default: " + this.queryTxt)
    this.listDoctors()
    //    }
    // this.$forceUpdate();
  },

  methods: {
    //SORTING
    labelSort(event) {
      switch (event.target.textContent.trim()) {
        case "name":
          this.sortBy("Doctor")
          break

        case "city":
          this.sortBy("City")
          break

        case "state":
          this.sortBy("State")
          break

        case "zipcode":
          this.sortBy("Zip")
          break

        /*
        case "country":
          this.sortBy("Country");
          break;
        */

        case "specialization":
          this.sortBy("Specialization")
          break

        default:
          return null
      }
    },
    sortBy(srt) {
      this.rstlQual = ""

      if (srt == "Doctor") {
        if (this.api_Route == this.route_lastName) {
          this.api_Route = this.route_lastNameDesc
        } else {
          this.api_Route = this.route_lastName
        }
      }

      if (srt == "City") {
        if (this.api_Route == this.route_city) {
          this.api_Route = this.route_cityDesc
        } else {
          this.api_Route = this.route_city
        }
      }

      if (srt == "State") {
        if (this.api_Route == this.route_state) {
          this.api_Route = this.route_stateDesc
        } else {
          this.api_Route = this.route_state
        }
        this.filterState = true
      }

      if (srt == "Zip") {
        if (this.api_Route == this.route_zip) {
          this.api_Route = this.route_zipDesc
        } else {
          this.api_Route = this.route_zip
        }
      }

      if (srt == "Specialization") {
        if (this.api_Route == this.route_specialization) {
          this.api_Route = this.route_specializationDec
        } else {
          this.api_Route = this.route_specialization
        }
      }

      if (srt == "Country") {
        // console.log("Sorting by country");
        if (this.api_Route == this.route_country) {
          this.api_Route = this.route_countryDec
        } else {
          this.api_Route = this.route_country
        }
      }

      this.listDoctors(this.api_Route)
    },

    refresh() {
      this.searchTxt = ""
      this.queryTxt = ""
      this.queryLabel = "query"
      this.rstlQual = ""
      this.selected = []
      this.activeURL = this.defaultURL
      this.listDoctors()
      this.$forceUpdate()
    },

    getSelected(item) {
      this.selected = item
    },

    chkChange(item) {
      if (this.selected.indexOf(item.id) > -1) {
        this.addReferral(item)
      } else {
        this.removeReferral(item)
      }
    },

    showDocDetail(doctor) {
      this.selectedDoctor = doctor;
      this.showDocDetails = true;
    },

    addReferral(item) {
      var _occupation = ""
      var _phone = ""

      if (item.Qualification.indexOf("MD") > -1) {
        _occupation = "Ophthalmologist MD"
      }
      if (item.Qualification.indexOf("DO") > -1) {
        _occupation = "Ophthalmologist DO"
      }
      if (item.Qualification.indexOf("OD") > -1) {
        _occupation = "Optometrist OD"
      }

      _phone = item.CellNumber ? item.CellNumber : item.Phone

      const _referral = {
        id: item.id,
        doctorId: item.expr1,
        userId: item.expr2,
        name: item.FullName,
        occupation: _occupation,
        web: item.Website,
        practice: item.Practice,
        address: item.Address,
        city: item.City,
        state: item.State,
        zip: item.Zip,
        phone: _phone,
        email: item.Email
      }
      this.referrals.push(_referral)     
    },

    removeReferral(item) {
      for (let idx = 0; idx < this.referrals.length; idx++) {
        const element = this.referrals[idx]
        if (element.id == item.id) {
          this.referrals.splice(idx, 1)
          break
        }
      }
    },

    getClass(item) {
      if (this.selected.indexOf(item.id) > -1) {
        return "table-selected"
      }
    },

    ProfileImageFile: function (fi) {
      const profileFolder = "../assets/img/profiles/"
      console.log(fi)
      return profileFolder + fi
    },

    filterCAEC() {
      this.doctorsList = this.doctorsList.filter((dr) => dr.Practice.indexOf("Center For Advanced Eye Care") > -1)
    },

    showModal(e) {
      this.doctor = this.doctors.find((x) => x.id === e)
      //showModalDrDetail();  ==> TODO
    },

    getList(listType) {
      if (listType == "NAME") {
        this.rstlQual = this.queryLabel = "Name"
        this.activeURL = "/dractive/name/" + this.queryTxt
      }
      if (listType == "ZIPCODE") {
        this.rstlQual = this.queryLabel = "ZIP Code"
        this.activeURL = "/dractive/zip/" + this.queryTxt
      }
      if (listType == "STATE") {
        this.rstlQual = this.queryLabel = "State"
        this.activeURL = "/dractive/state/" + this.queryTxt
      }
      if (listType == "COUNTRY") {
        this.rstlQual = this.queryLabel = "Country"
        this.activeURL = "/dractive/country/" + this.queryTxt
      }
      if (listType == "QUALS") {
        this.rstlQual = this.queryLabel = "Qualifications"
        this.activeURL = "/dractive/quals/" + this.queryTxt
      }
      if (listType == "BIZ") {
        this.rstlQual = this.queryLabel = "Business/Website"
        this.activeURL = "/dractive/biz/" + this.queryTxt
      }
      this.listDoctors()
    },

    async listDoctors() {
      const url = process.env.VUE_APP_URL + this.endpoint
      const config = {
        headers: {
          "Content-Type": "application/json"
          //'Access-Control-Allow-Origin': '*',
        }
      }
      var vm = this
      const data = null

      // console.log("listDoctors:GET: " + url)
      await window.axios
        .get(url, data, config, { useCache: false })
        .then((r) => r.data)
        .then((data) => {
          this.doctorsList = data.items
          this.doctorsListCount = data.count
          // console.log("Doctors GET: ", data);
        })
        .catch((err) => {
          console.log(err)
        })
    },

    lookupZip() {
      const url =
        "https://www.zipcodeapi.com/rest/ZmsSABx9wEo50ELHCzdG7ptg1LzGbvjmAYWibfzWmuKGYz8UQzwOXdKbQq7vrNAJ/info.json/34945/degrees"
      const config = {
        headers: {
          "Access-Control-Allow-Origin": "http://127.0.0.1:8080",
          "Access-Control-Allow-Credentials": "true",
          "Access-Control-Allow-Methods": "GET, POST, OPTIONS",
          "Access-Control-Allow-Headers": "Origin, Content-Type, Accept"
        }
      }
      const data = null
      // console.log("lookupZip:GET: " + url);
      window.axios.get(url, data, config).then((r) => {
        console.log(r.data)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
#referral {
  width: 95%;
  margin-left: 20px;
  display: inline-block;
  vertical-align: top;
}

.md-table {
  height: 55vh;
  overflow: auto;
  cursor: pointer;
}

.md-table-cell {
  padding: 2px 8px;
  font-size: 14px;
}

.text-right ::v-deep .md-table-cell-container {
  display: flex;
  justify-content: flex-end;
}

.md-table ::v-deep .md-table-head:last-child {
  text-align: right;
}

.table-shopping {
  table > thead > tr > th {
    //font-size: $font-size-h6;
    text-transform: uppercase;
  }

  table > thead > tr > .md-table-head .md-table-head-label {
    font-size: 0.75rem;

    b {
      display: block;
      margin-bottom: 3px;
    }
  }

  .td-name {
    //font-weight: $font-weight-default;
    font-size: 1em !important;
    line-height: 1.1;

    small {
      color: green;
      font-size: 0.77em;
      //font-weight: $font-weight-light;
    }
  }

  //.td-number{
  //font-weight: $font-weight-light;
  //font-size: $font-size-h4;
  //}
  .td-name {
    min-width: 200px;
  }

  .td-number {
    text-align: right;
    min-width: 150px;

    small {
      margin-right: 3px;
    }
  }

  .img-container {
    width: 120px;
    max-height: 160px;
    overflow: hidden;
    display: block;

    img {
      width: 100%;
    }
  }
}

.md-table-row:hover {
  background-color: #74b5ff !important;
  color: white;
}

.table-striped {
  tbody > tr:nth-of-type(odd) {
    background-color: #edf2f7;
  }

  tbody > tr:nth-of-type(even) {
    background-color: #ffffff;
  }
}

.table-selected {
  color: white;
  background-color: #005ac2 !important;

  a,
  small {
    color: white;
  }
}

.modal-container-referral {
  max-width: 70vw;
  max-height: 75vh !important;
  overflow: auto;
  margin: 0px auto;
  position: relative;
  background-color: #fff;
  transition: all 0.3s ease;
  box-shadow: 0 27px 24px 0 rgba(0, 0, 0, 0.2), 0 40px 77px 0 rgba(0, 0, 0, 0.22);
  border-radius: 6px;
  border: none;
  z-index: 9999;
}

.dropdown {
  cursor: pointer;
}

.dropdown-menu {
  li:hover {
    background-color: #005ac2 !important;
    color: #fff !important;
  }
}
.doc-modal {
  position: relative;
  padding: 1.5rem;
  background-color: white;
  border-radius: 10px;
  min-width: 300px;
  max-width: 600px;
  margin: auto;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
}

.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
}

.doc-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.doc-icon {
  font-size: 2rem;
  color: #ffffff;
  background-color: #607d8b;
  border-radius: 50%;
  padding: 0.7rem;
}

.doc-name {
  font-size: 1.25rem;
  font-weight: 600;
  color: #333;
}

.doc-details {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  font-size: 0.95rem;
  color: #555;
}

.doc-detail-row {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #eee;
  padding-bottom: 4px;
}

.doc-footer {
  margin-top: 2rem;
  font-size: 0.85rem;
  color: #999;
}

</style>
